/* ===========================
IMPORTS
=========================== */
import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import ReactDOMClient from 'react-dom/client';
import PropTypes from 'prop-types';
// IMPORT - STYLING
// IMPORT - COMPONENTS
import ModalComment from './ModalComment';
import ModalBatchMaintenance from './ModalBatchMaintenance';
import ModalBatchCriticalUpdate from './ModalBatchCriticalUpdate';
// IMPORT - ELEMENTS
import Modal from '../Elements/Modal';
import Tables from '../Elements/Tables';
import CopyToClipboard from '../Elements/CopyToClipboard';
import { IconPlus } from '../Elements/Icons';
// IMPORT - Helpers
import Helpers from '../../Helpers';

/* ===========================
CLASS
=========================== */
class CanvasList extends React.Component {
  /* ===========================
  DEFAULT
  =========================== */
  /**
   * Main constructor of Component
  */
  constructor(props) {
    super(props);
    this.state = {
      // For table component
      errors: null,
      data: [],
      meta: {},
      page: 1,
      limit: 50,
      columns: {},
      search: '',
      sortBy: 'called_at',
      direction: 'desc',
      loading: true,
      focus: null,

      optionsLimits: {
        50: true,
        100: false,
        250: false,
      },

      optionsColumns: [
        'device_id',
        'name',
        'group_name',
        'tenant_name',
        'stack_host',
        'bundle',
        'bundle_rule_name',
        'timezone',
        'product_sn',
        'dpc_sn',
        'tags',
        'called_at',
        'created_at',
        {
          name: 'manufacturing',
          columns: [
            'HW_INFO',
            'PRODUCT_PARTNUM',
            'LAN_MAC',
            'PSLD_SN',
            'WIFI_MAC1',
            'WIFI_MAC2',
            'BT_MAC',
            'PALLET_NO',
            'SHIP_DATE',
            'BUILD_DATE',
          ],
        },
      ],

      optionsColumnsDefault:
      [
        'name',
        'device_id',
        'group_name',
        'stack_host',
        'bundle',
        'bundle_rule_name',
        'timezone',
        'called_at',
      ],

      optionsColumnLabels: {
        name: 'Name',
        device_id: 'Device ID',
        stack_host: 'Domain',
        group_name: 'Group',
        tenant_name: 'Tenant',
        bundle: 'Bundle',
        bundle_rule_name: 'Bundle Rule',
        timezone: 'Timezone',
        called_at: 'Last Check-In',
        product_sn: 'Serial Number',
        dpc_sn: 'DPC Serial',
        tags: 'Tags',
        created_at: 'Created',
        'manufacturing.HW_INFO': 'Hardware',
        'manufacturing.PRODUCT_PARTNUM': 'Part Number',
        'manufacturing.LAN_MAC': 'Ethernet MAC',
        'manufacturing.PSLD_SN': 'PSLD Serial',
        'manufacturing.WIFI_MAC1': 'WiFi MAC 1',
        'manufacturing.WIFI_MAC2': 'WiFi MAC 2',
        'manufacturing.BT_MAC': 'Bluetooth MAC',
        'manufacturing.PALLET_NO': 'Pallet No.',
        'manufacturing.SHIP_DATE': 'Shipping Date',
        'manufacturing.BUILD_DATE': 'Build Date',
      },

      optionsColumnsSortable: [
        'id',
        'device_id',
        'name',
        'stack_host',
        'timezone',
        'group_name',
        'tenant_name',
        'product_sn',
        'dpc_sn',
        'tags',
        'called_at',
        'created_at',
      ],

      // For modal components
      modals: {
        comment: false,
        batchcriticalupdate: false,
        batchmaintenance: false,
      },

      modalData: null,
      modalSubmitted: false,
      loadingModal: true,
    };

    this.get = this.get.bind(this);
    this.updateShowModal = this.updateShowModal.bind(this);
    this.updateLoadingModal = this.updateLoadingModal.bind(this);
    this.updateModalSubmitted = this.updateModalSubmitted.bind(this);
    this.updateColumns = this.updateColumns.bind(this);
    this.updateColumnsShowHide = this.updateColumnsShowHide.bind(this);
    this.updateLimits = this.updateLimits.bind(this);
    this.updateSearch = this.updateSearch.bind(this);
    this.updatePage = this.updatePage.bind(this);
    this.onClickRow = this.onClickRow.bind(this);
    this.updateSortDirection = this.updateSortDirection.bind(this);
  }

  /**
   * componentDidMount
   */
  componentDidMount() {
    // Show the component
    this.props.updateLoadingApp(false);
    this.props.updateLoadingContent(false);
    this.get();

    // Load default settings
    try {
      if (localStorage.defaultColumnsCanvasesList === undefined
        || JSON.parse(localStorage.defaultColumnsCanvasesList).length === 0) {
        localStorage.defaultColumnsCanvasesList = JSON.stringify(this.state.optionsColumnsDefault);
      }
      this.setState({
        optionsColumnsDefault: JSON.parse((localStorage.defaultColumnsCanvasesList || [])),
      });
    } catch (e) {
      this.setState({
        errors: {
          message: 'Could load saved preferences.',
        },
      });
    }
  }

  /* ===========================
  FUNCTIONS
  =========================== */
  /**
   *
   */
  searchTimeout = null;

  /**
   * Handler before API request
   */
  get(params, callback, failback) {
    this.setState({
      errors: null,
      data: [],
      loading: true,
    }, () => {
      // Make initial request
      const defaultPayload = {
        page: this.state.page,
        limit: this.state.limit,
        order_by: `${this.state.sortBy}.${this.state.direction}`,
      };

      if (this.state.search && this.state.search.length > 0) {
        defaultPayload.search = this.state.search;
      }

      Object.keys(this.state.columns).map((item) => {
        if (this.state.columns[item].search && this.state.columns[item].search.length > 0) {
          defaultPayload[item] = this.state.columns[item].search;
        }
        return item;
      });

      CanvasList.request(
        (params || defaultPayload),
        // callback
        (response) => {
          if (callback) {
            callback(response);
          } else if (response.players && response.meta) {
            const columns = {};

            (this.state.optionsColumns).map((item) => {
              if (typeof (item) === 'object' && item.name) {
                columns[item.name] = {
                  label: (this.state.optionsColumnLabels[item.name])
                    ? this.state.optionsColumnLabels[item.name]
                    : null,
                  search: (this.state.columns[item.name])
                    ? this.state.columns[item.name].search
                    : '',
                  parent: false,
                  sortable: (this.state.optionsColumnsSortable.indexOf(item.name) > -1),
                };

                if (this.state.columns[item.name] && this.state.columns[item.name].visible) {
                  columns[item.name].visible = this.state.columns[item.name].visible;
                } else if (this.state.optionsColumnsDefault
                  && this.state.optionsColumnsDefault.indexOf(item.name) === -1) {
                  columns[item.name].visible = false;
                } else {
                  columns[item.name].visible = true;
                }

                if (item.columns && item.columns.length > 0) {
                  item.columns.map((child) => {
                    columns[`${item.name}.${child}`] = {
                      label: (this.state.optionsColumnLabels[`${item.name}.${child}`])
                        ? this.state.optionsColumnLabels[`${item.name}.${child}`]
                        : null,
                      search: (this.state.columns[`${item.name}.${child}`])
                        ? this.state.columns[`${item.name}.${child}`].search
                        : '',
                      parent: item.name,
                      sortable: (this.state.optionsColumnsSortable.indexOf(`${item.name}.${child}`) > -1),
                    };

                    if (this.state.columns[`${item.name}.${child}`] && this.state.columns[`${item.name}.${child}`].visible) {
                      columns[`${item.name}.${child}`].visible = this.state.columns[`${item.name}.${child}`].visible;
                    } else if (this.state.optionsColumnsDefault
                      && this.state.optionsColumnsDefault.indexOf(`${item.name}.${child}`) === -1) {
                      columns[`${item.name}.${child}`].visible = false;
                    } else {
                      columns[`${item.name}.${child}`].visible = true;
                    }

                    return child;
                  });
                }
              } else {
                columns[item] = {
                  label: (this.state.optionsColumnLabels[item])
                    ? this.state.optionsColumnLabels[item]
                    : null,
                  search: (this.state.columns[item])
                    ? this.state.columns[item].search
                    : '',
                  parent: false,
                  sortable: (this.state.optionsColumnsSortable.indexOf(item) > -1),
                };

                if (this.state.columns[item] && this.state.columns[item].visible) {
                  columns[item].visible = this.state.columns[item].visible;
                } else if (this.state.optionsColumnsDefault
                  && this.state.optionsColumnsDefault.indexOf(item) === -1) {
                  columns[item].visible = false;
                } else {
                  columns[item].visible = true;
                }
              }

              return item;
            });

            this.setState({
              data: response.players,
              meta: response.meta,
              columns,
              loading: false,
            }, () => {
              // refocus on original input element
              if (this.state.focus) {
                document.getElementById(this.state.focus).focus();
              }
            });
          } else {
            this.setState({
              loading: false,
            });
          }
        },
        // failback
        (error) => {
          if (failback) {
            failback(error);
          } else if (error) {
            this.setState({
              errors: error,
              loading: false,
            });
          }
        },
      );
    });
  }

  /**
   * Main API request
   */
  static request(params, callback, failback) {
    let query = '';
    if (params && Object.keys(params).length > 0) {
      Object.keys(params).map((key) => {
        query += `${key}=${params[key]}&`;
        return key;
      });
      query = `?${query}`;
    }

    Helpers.httpRequest(
      `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}/players${query}`,
      'get',
      null,
      // callback
      (response) => {
        if (callback) {
          callback(response);
        }
      },
      // failback
      (error) => {
        if (failback) {
          failback(error);
        }
      },
    );
  }

  /**
  * @param {boolean} show
  */
  updateLoadingModal(show) {
    this.setState({
      loadingModal: show,
    });
  }

  /**
  * @param {string} modal
  */
  updateShowModal(modal, show) {
    const { modals } = this.state;
    modals[modal] = show;
    this.setState({
      modals,
    });
  }

  /**
  * @param {boolean} submitted
  */
  updateModalSubmitted(submitted) {
    this.setState({
      modalSubmitted: submitted,
    });
  }

  /**
   * @param {object} columns
   * @param {string} key
   */
  updateColumnsShowHide(columns, key, show) {
    // Set defaults for localStorage
    if (localStorage.defaultColumnsCanvasesList
      && localStorage.defaultColumnsCanvasesList.length > 0) {
      let def = JSON.parse(localStorage.defaultColumnsCanvasesList);
      if (show) {
        def.push(key);
      } else {
        def = [...def.slice(0, def.indexOf(key)), ...def.slice((def.indexOf(key) + 1))];
      }
      localStorage.defaultColumnsCanvasesList = JSON.stringify(def);
    } else {
      localStorage.defaultColumnsCanvasesList = JSON.stringify([key]);
    }

    if (columns[key].search.length > 0 && !show) {
      const newColumns = { ...columns };
      newColumns[key].search = '';
      this.setState({
        columns: newColumns,
        focus: null,
        optionsColumnsDefault: JSON.parse(localStorage.defaultColumnsCanvasesList),
      }, () => {
        this.get();
      });
    } else { // if no search was present just hide/show the field
      this.setState({
        columns,
        focus: null,
        optionsColumnsDefault: JSON.parse(localStorage.defaultColumnsCanvasesList),
      });
    }
  }

  /**
   * @param {object} columns
   */
  updateColumns(columns, targetId) {
    this.setState({
      columns,
      focus: (targetId || null),
    }, () => {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.get();
      }, 500);
    });
  }

  /**
   * @param {object} limits
   */
  updateLimits(limits) {
    this.setState({
      page: 1,
      limit: Object.keys(limits).filter((item) => (limits[item]))[0],
      optionsLimits: limits,
    }, () => {
      this.get();
    });
  }

  /**
   * @param {string} search
   */
  updateSearch(search, targetId) {
    this.setState({
      search,
      focus: (targetId || null),
    }, () => {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.get();
      }, 500);
    });
  }

  /**
   * @param {integer} page
   */
  updatePage(page) {
    this.setState({
      page,
    }, () => {
      this.get();
    });
  }

  /**
   * @param {Event} event
   * @param {object} data
   */
  onClickRow(event, data) {
    if (data.id) {
      this.props.history.push(`/dashboard/canvases/${data.id}`);
    }
    event.preventDefault();
  }

  /**
   * @param {string} data
   */
  static onCopyToClipboard(data) {
    const container = document.getElementById('hidden');
    const root = ReactDOMClient.createRoot(container);

    root.render(
      <CopyToClipboard data={data} callback={() => root.render('')} />,
    );
  }

  /**
   * @param {string} key
   */
  updateSortDirection(key) {
    this.setState((prevState) => {
      let direction = (prevState.direction === 'asc')
        ? 'desc'
        : 'asc';
      direction = (prevState.sortBy !== key)
        ? 'asc'
        : direction;
      return {
        sortBy: key,
        direction,
      };
    }, () => {
      this.get();
    });
  }

  /* ===========================
  RENDER
  =========================== */
  render() {
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col col-12">

            <div className="page-header">
              <Link className="btn btn-rounded btn-primary float-right" to="/dashboard/canvases/upload">
                <IconPlus />
                {' '}
                Upload
              </Link>
              <h1>Canvases</h1>
            </div>

            {(this.state.errors)
              ? (
                <div className="errors">
                  <div className="alert alert-danger">{(this.state.errors.message) ? this.state.errors.message : 'Something went wrong.'}</div>
                </div>
              )
              : ''}

            <div className="content">
              <Tables
                uniqueKey="id"
                search={this.state.search}
                data={this.state.data}
                meta={this.state.meta}
                page={this.state.page}
                limit={this.state.limit}
                columns={this.state.columns}
                sortBy={this.state.sortBy}
                direction={this.state.direction}
                loading={this.state.loading}
                optionsLimits={this.state.optionsLimits}
                optionsSelections={{
                  copy: {
                    label: 'Copy To Clipboard',
                    action: (data) => {
                      const deviceIds = this.state.data.map((item) => ((data.indexOf(item.id) > -1)
                        ? item.device_id
                        : null)).filter((item) => item);

                      CanvasList.onCopyToClipboard(deviceIds);
                    },
                  },
                  batchcritical: {
                    label: 'Critical Update',
                    action: (data) => {
                      this.setState((prevState) => {
                        const deviceIds = prevState.data.map((item) => ((data.indexOf(item.id) > -1)
                          ? item.device_id
                          : null)).filter((item) => item);

                        return {
                          modalData: deviceIds,
                        };
                      }, () => {
                        this.updateShowModal('batchcriticalupdate', true);
                      });
                    },
                  },
                  batchmaintenance: {
                    label: 'Maintenance Window',
                    action: (data) => {
                      this.setState((prevState) => {
                        const deviceIds = prevState.data.map((item) => ((data.indexOf(item.id) > -1)
                          ? item.device_id
                          : null)).filter((item) => item);

                        return {
                          modalData: deviceIds,
                        };
                      }, () => {
                        this.updateShowModal('batchmaintenance', true);
                      });
                    },
                  },
                }}
                optionsRows={{
                  comment: {
                    label: 'Comment',
                    action: (data) => {
                      const { modals } = this.state;
                      modals.comment = true;
                      this.setState({
                        modals,
                        modalData: data,
                      });
                    },
                  },
                  batchcritical: {
                    label: 'Critical Update',
                    action: (data) => {
                      this.setState({
                        modalData: [data.device_id],
                      }, () => {
                        this.updateShowModal('batchcriticalupdate', true);
                      });
                    },
                  },
                  batchmaintenance: {
                    label: 'Maintenance Window',
                    action: (data) => {
                      this.setState({
                        modalData: [data.device_id],
                      }, () => {
                        this.updateShowModal('batchmaintenance', true);
                      });
                    },
                  },
                }}
                onUpdateSearch={this.updateSearch}
                onUpdatedColumns={this.updateColumns}
                onUpdateColumnsShowHide={this.updateColumnsShowHide}
                onUpdatedLimits={this.updateLimits}
                onUpdatePage={this.updatePage}
                onUpdateSortDirection={this.updateSortDirection}
                onClickRow={this.onClickRow}
              />

              {(this.state.modals.comment)
                ? (
                  <Modal
                    title="Comment"
                    loading={this.state.loadingModal}
                    updateLoadingModal={this.updateLoadingModal}
                    submitted={this.state.modalSubmitted}
                    cancel={(event) => {
                      this.updateShowModal('comment', false);
                      event.preventDefault();
                    }}
                    buttonCloseLabel="Close"
                    buttonCloseAction={(event) => {
                      this.updateShowModal('comment', false);
                      event.preventDefault();
                    }}
                    buttonSubmitLabel="Save"
                    buttonSubmitStyle="btn-success"
                    buttonSubmitAction={(event) => {
                      const form = document.getElementById('modal-list-comment');
                      form.getElementsByTagName('button')[0].click();
                      event.preventDefault();
                    }}
                  >
                    <ModalComment
                      id="modal-list-comment"
                      data={this.state.modalData}
                      submitted={this.state.modalSubmitted}
                      handleSubmit={this.updateModalSubmitted}
                      handleSubmitSuccess={() => {
                        this.updateShowModal('comment', false);
                      }}
                      loading={this.state.loadingModal}
                      updateLoadingModal={this.updateLoadingModal}
                    />
                  </Modal>
                )
                : ''}

              {(this.state.modals.batchcriticalupdate)
                ? (
                  <Modal
                    title="Critical Update"
                    loading={this.state.loadingModal}
                    updateLoadingModal={this.updateLoadingModal}
                    submitted={this.state.modalSubmitted}
                    cancel={(event) => {
                      this.updateShowModal('batchcriticalupdate', false);
                      event.preventDefault();
                    }}
                    buttonCloseLabel="Close"
                    buttonCloseAction={(event) => {
                      this.updateShowModal('batchcriticalupdate', false);
                      event.preventDefault();
                    }}
                    buttonSubmitLabel="Save"
                    buttonSubmitStyle="btn-success"
                    buttonSubmitAction={(event) => {
                      const form = document.getElementById('modal-list-batchcriticalupdate');
                      form.getElementsByTagName('button')[0].click();
                      event.preventDefault();
                    }}
                  >
                    <ModalBatchCriticalUpdate
                      id="modal-list-batchcriticalupdate"
                      data={this.state.modalData}
                      submitted={this.state.modalSubmitted}
                      handleSubmit={this.updateModalSubmitted}
                      handleSubmitSuccess={() => {
                        this.updateShowModal('batchcriticalupdate', false);
                      }}
                      loading={this.state.loadingModal}
                      updateLoadingModal={this.updateLoadingModal}
                    />
                  </Modal>
                )
                : ''}

              {(this.state.modals.batchmaintenance)
                ? (
                  <Modal
                    title="Maintenance Window"
                    loading={this.state.loadingModal}
                    updateLoadingModal={this.updateLoadingModal}
                    submitted={this.state.modalSubmitted}
                    cancel={(event) => {
                      this.updateShowModal('batchmaintenance', false);
                      event.preventDefault();
                    }}
                    buttonCloseLabel="Close"
                    buttonCloseAction={(event) => {
                      this.updateShowModal('batchmaintenance', false);
                      event.preventDefault();
                    }}
                    buttonSubmitLabel="Save"
                    buttonSubmitStyle="btn-success"
                    buttonSubmitAction={(event) => {
                      const form = document.getElementById('modal-list-batchmaintenance');
                      form.getElementsByTagName('button')[0].click();
                      event.preventDefault();
                    }}
                  >
                    <ModalBatchMaintenance
                      id="modal-list-batchmaintenance"
                      data={this.state.modalData}
                      submitted={this.state.modalSubmitted}
                      handleSubmit={this.updateModalSubmitted}
                      handleSubmitSuccess={() => {
                        this.updateShowModal('batchmaintenance', false);
                      }}
                      loading={this.state.loadingModal}
                      updateLoadingModal={this.updateLoadingModal}
                    />
                  </Modal>
                )
                : ''}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

/* ===========================
PROPERTY TYPES
=========================== */
CanvasList.propTypes = {
  updateLoadingApp: PropTypes.func,
  updateLoadingContent: PropTypes.func,
  history: PropTypes.object,
};

/* ===========================
EXPORT
=========================== */
export default withRouter(CanvasList);
